import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-showcase-sheet',
  templateUrl: './showcase-sheet.component.html',
  styleUrls: ['./showcase-sheet.component.scss']
})
export class ShowcaseSheetComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
